import { EventModel } from 'features/events/EventModel';
import { liveEventSelector } from 'features/events/eventsSelectors';
import { useEffect, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useAudio } from 'features/audio/audio';
import { useAppSelector } from 'hooks/redux';

export const useAutoPlayEventAfterNavigation = (event: EventModel | null) => {
  const location = useLocation() as any;
  const { loadAudio } = useAudio();
  const audioUrl = useAppSelector((state) => state.audio.url);
  const audioIsPlaying = useAppSelector((state) => state.audio.playing);
  const { isNativeAppWebview, isBrowserEmbed } = useContext(UserAgentContext);
  const isAnimatingLayout = useAppSelector(
    (state) => state.ui.isAnimatingLayout
  );
  const liveEvent: EventModel | null = useAppSelector(liveEventSelector);
  const hasLoadedAudioRef = useRef<boolean>(false);

  useEffect(
    function autoPlayAudioAfterNavigation() {
      if (isNativeAppWebview || isBrowserEmbed || isAnimatingLayout) return;
      if (!audioUrl) return;
      if (liveEvent && event?.id !== liveEvent?.id) return;
      if (audioIsPlaying) return;
      if (hasLoadedAudioRef.current) return;
      if (location.state && location.state.autoPlay) {
        console.log(
          '[useAutoPlayEventAfterNavigation] - Auto playing event audio after navigating'
        );
        loadAudio({
          audioSrc: audioUrl,
          autoPlay: true,
          audioType: 'event'
        });
        hasLoadedAudioRef.current = true;
      }
    },
    [
      isNativeAppWebview,
      isBrowserEmbed,
      isAnimatingLayout,
      liveEvent,
      event,
      audioUrl,
      audioIsPlaying,
      location,
      loadAudio
    ]
  );
};
